import axios from 'axios';
import store from '../../../vuex/store'
import keys from '../../../config/keys.json'
import { getCloudFunctionBase } from '../../../config/deployment'

const npsUri = getCloudFunctionBase() + "/cf-usage-stats/nps"

export const reportNpsScore=(score)=>{
    try{
        var uid = store.getters.user.uid
        if(score && uid){
            var data = {
                reporterUid: uid,
                score: score
            }
            var headers = {"Authorization": keys.internal_cf_auth_token};
            axios.post(npsUri, data, { headers: headers })
                .then(resp => {
                })
                .catch(err =>{
                })
        }
    }catch(error){
    }
}

export const getUserLatestNpsScore=(uid)=>{
    return new Promise((resolve, reject) => {
        if(!uid) reject("uid required")
        return axios.get(npsUri+"/latest?uid="+uid, { headers: {"Authorization": keys.internal_cf_auth_token} })
            .then(resp => {
                if(resp.data.result) resolve(resp.data.result)
                else reject(404)
            })
            .catch(err =>{
                reject(err)
            })
    
    })
}


// WEBPACK FOOTER //
// ./src/platform/analytics/services/usageStatsService.js